
/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
*  Copyright © 2025 Pearson Education, Inc.
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Pearson Education, Inc.  The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
* patent applications, and are protected by trade secret or copyright law.
* Dissemination of this information, reproduction of this material, and copying or distribution of this software
* is strictly forbidden unless prior written permission is obtained
* from Pearson Education, Inc.
* */
/**
 * Collapse button styles
 *
 * @file CollapseButtonStyles.jsx
 * @author Gladson Samuel S
 * @since 1.0.0
 */
import { styled } from '@mui/material/styles';
import TooltipMui, { tooltipClasses } from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import mixins from '../../../../assets/styles/mixins.scss';

export const expandCollapseGlobalStyles = {
  '[class*="preference-theme-Black"] .expand-collapse-button svg path': {
    color: mixins.whiteFont,
    fill: mixins.whiteFont
  },
  '[class*="preference-theme-White"] .expand-collapse-button-collapsed-popper .MuiTooltip-tooltip, [class*="preference-theme-Akaroa"] .expand-collapse-button-collapsed-popper .MuiTooltip-tooltip': {
    color: mixins.whiteFont,
    backgroundColor: mixins.profileFontColor
  },
  '[class*="preference-theme-White"] .expand-collapse-button-collapsed-popper .MuiTooltip-arrow, [class*="preference-theme-Akaroa"] .expand-collapse-button-collapsed-popper .MuiTooltip-arrow': {
    color: mixins.profileFontColor
  }
};

export const ExpandCollapseButtonContainer = styled(IconButton)({
  '&&': {
    display: 'flex',
    width: 48,
    minHeight: 48,
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'none',

    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

export const StyledTooltip = styled(({ className, popperClassName, ...props }) => (
  <TooltipMui {...props} classes={{ popper: `${className} ${popperClassName || ''}`.trim() }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    boxSizing: 'border-box',
    fontFamily: mixins.fontFamilyTT,
    backgroundColor: mixins.whiteLightFont,
    color: mixins.darkThemeColor,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight700,
    fontSize: mixins.fontSize14,
    lineHeight: mixins.fontSize24,
    margin: 0,
    padding: '8px 12px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16)',

    '&.variant1': {
      padding: '4px 15px',
      position: 'relative',
      lineHeight: '20px',
      borderRadius: '9px',
      fontWeight: mixins.fontWeight500,
      fontFamily: 'unset',
      color: mixins.copyright,
      backgroundColor: mixins.whiteLightFont
    }
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: mixins.whiteLightFont,

    '&.variant1': {
      top: '-4px !important',
      fontSize: '28px',
      marginLeft: '-0.51em !important',
      color: mixins.whiteLightFont
    }
  },
  '&[x-out-of-boundaries]': {
    display: 'none'
  }
});
